import { readStoredValue } from '@/utils/storage';

const storedUserEmail = readStoredValue('admin_selectedUserEmail');

export default {
  stSessionId: null,
  user: null,
  role: {
    isSuperAdmin: true,
    isAccountAdmin: true,
    master: true,
    permissions: { canViewPermissions: true }
  },
  requestStatus: 'loading',
  repliersById: {},
  activeUserEmail: storedUserEmail || null
};
